<template>
  <eagle-list
    :list-key="listKey"
  ></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './contactListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'contact-list',
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.contactApi.index(params)
    },
    async patchApi(value, row, config) {
      const target = row.id
      const column = config.key
      return await this.$api.collection.contactApi.patch(target, column, value)
    },
    async deleteApi(target) {
      return await this.$api.collection.contactApi.delete(target)
    },
    async batchApi(targets, column, value) {
      return await this.$api.collection.contactApi.batch(targets, column, value)
    },
    async batchDeleteApi(targets) {
      return await this.$api.collection.contactApi.batchDelete(targets)
    },
    getListConfig() {
      return listConfig
    },
  },
  computed: {
    feature() {
      return this.$store.getters['base/feature']
    },
    orderModule() {
      return this.feature.orderModule === true
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
